import type { Chapter } from '@gbcmc/survey-core';
import { ChapterArt } from './ChapterArt';

// Marca de agua del capítulo detrás de la tarjeta de pregunta (handoff §11).
// Modo fijo "fondo" con opacidad 8 % (valores finales del prototipo; el panel
// de Tweaks no se porta a producción).
const BG_OPACITY = 0.08;

export function ChapterBackground({ chapter }: { chapter: Chapter }) {
  return (
    <div className="gb-bg gb-bg--wash" aria-hidden="true" style={{ opacity: BG_OPACITY }}>
      <ChapterArt kind={chapter.illustration} />
    </div>
  );
}
